const routes = [
  {
    path: "/itemizable",
    name: "newItemizableDialog",
    component: () => import(/* webpackChunkName: "Itemizable" */ "./views/Itemizable")
  },

];
export default routes;
